import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Avatar, Typography, Paper } from '@mui/material';
import { getShortName, getInitials, getPersonAvatarUrl } from '../hooks/usePersonHelpers';

function PersonNode({ data }) {
  const { person, selected, showTop, showBottom, showLeft, showRight } = data;

  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        p: 1.5,
        minWidth: 120,
        textAlign: 'center',
        border: selected ? '2px solid' : '1px solid',
        borderColor: selected ? 'secondary.main' : 'divider',
        bgcolor: person.deceasedDate ? 'grey.100' : 'background.paper',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          elevation: 4,
          borderColor: 'primary.main',
        },
      }}
    >
      {showTop && (
        <Handle
          type="target"
          position={Position.Top}
          id="top"
          style={{ background: '#01362E', width: 8, height: 8 }}
        />
      )}
      {showLeft && (
        <Handle
          type="target"
          position={Position.Left}
          id="left"
          style={{ background: '#ff8f00', width: 8, height: 8 }}
        />
      )}
      {showRight && (
        <Handle
          type="source"
          position={Position.Right}
          id="right"
          style={{ background: '#ff8f00', width: 8, height: 8 }}
        />
      )}

      <Avatar
        src={getPersonAvatarUrl(person, 48)}
        alt={`Photo of ${getShortName(person)}`}
        sx={{
          width: 48,
          height: 48,
          mx: 'auto',
          mb: 1,
          border: '2px solid',
          borderColor: selected ? 'secondary.main' : 'primary.main',
          opacity: person.deceasedDate ? 0.7 : 1,
        }}
      >
        {getInitials(person)}
      </Avatar>

      <Typography
        variant="body2"
        fontWeight={500}
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {getShortName(person)}
      </Typography>

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
        }}
      >
        {person.lastName}
      </Typography>

      {showBottom && (
        <Handle
          type="source"
          position={Position.Bottom}
          id="bottom"
          style={{ background: '#01362E', width: 8, height: 8 }}
        />
      )}
    </Paper>
  );
}

export default memo(PersonNode);

